import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../locale";
import { getStatusStep } from "./orderDetailsUtils";
import OrderDetailsAlert from "./OrderDetailsAlert";

const OrderDetailsHeaderSection = ({
  currentOrder,
  admin,
  sales,
  isSeller,
  status,
  hasStoreBackUrl,
  canReadyForPickup,
  canChangeStatusToSent,
  canReceiveOrderButton,
  canReceiveDownloadLinksButton,
  isLoadingReadyForPickup,
  onGoBack,
  onOpenChat,
  onReadyForPickup,
  onChangeStatusToSent,
  onReceiveOrder,
  onReceiveDownloadLinks,
}) => {
  if (!currentOrder) return null;

  const stepLabels = [
    localeText("orderDetailsStep1Send"),
    localeText("orderDetailsStep2Delivered"),
    localeText("orderDetailsStep3Payment"),
    localeText("orderDetailsStep4Completed"),
  ];
  const currentStep = getStatusStep(status);

  return (
    <>
      <div className="order-details-header-row">
        <div className="order-details-header-left">
          <div className="order-details-header-icon">
            <i className="pi pi-history" />
          </div>
          <div>
            <h2 className="order-details-header-title">
              {localeText("storeOrderDetails") || localeText("orderDetails")}
              {admin ? ` #${currentOrder.id}` : ""}
            </h2>
            <p className="order-details-header-subtitle">
              {localeText("orderDetailsSubtitle") || localeText("storePanelSubtitle")}
            </p>
          </div>
        </div>
        <div className="order-details-header-actions">
          {!hasStoreBackUrl && (
            <Button
              label={localeText("backToOrdersList")}
              icon="pi pi-arrow-left"
              onClick={onGoBack}
              className="p-button-outlined p-button-secondary"
            />
          )}
          {!admin && (
            <Button
              onClick={onOpenChat}
              label={isSeller ? localeText("talkToBuyer") : localeText("talkToSeller")}
              className="p-button-outlined p-button-secondary"
              icon="pi pi-comments"
            />
          )}
          {!admin && sales && status === "PAID" && currentOrder.banggood_order === false && (
            <Button
              label={localeText("orderDetailsCancelOrder")}
              icon="pi pi-times"
              onClick={() => {}}
              className="p-button-outlined p-button-secondary"
            />
          )}
          {!admin && sales && canReadyForPickup && (
            <Button
              label={localeText("readyForPickup")}
              onClick={onReadyForPickup}
              disabled={isLoadingReadyForPickup}
              className="p-button-outlined p-button-secondary"
            />
          )}
          {!admin && sales && canChangeStatusToSent && (
            <Button
              label={localeText("changeStatusToSent")}
              onClick={onChangeStatusToSent}
              className="p-button-outlined p-button-secondary"
            />
          )}
          {canReceiveOrderButton && (
            <Button
              label={localeText(
                currentOrder?.pickinaddress ? "productWasPickedUp" : "receiveOrder",
              )}
              onClick={onReceiveOrder}
              className="p-button-outlined p-button-secondary"
            />
          )}
          {canReceiveDownloadLinksButton && (
            <Button
              label={localeText("receiveDownloadLinks")}
              onClick={onReceiveDownloadLinks}
              className="p-button-outlined p-button-secondary"
            />
          )}
        </div>
      </div>

      <div className="order-details-stepper">
        {[1, 2, 3, 4].map((step) => {
          const completed = currentStep > step;
          const current = currentStep === step;
          const label = stepLabels[step - 1];
          return (
            <React.Fragment key={step}>
              <div
                className={`flex align-items-center justify-content-between border-round-md p-2 flex-1 ${
                  completed
                    ? "order-details-step--completed"
                    : current
                      ? "order-details-step--current"
                      : "order-details-step--pending"
                }`}
              >
                <div className="flex align-items-center gap-2 text-sm">
                  <span className="order-details-step-icon">
                    {completed ? <i className="pi pi-check text-xs font-bold" /> : <span>{step}</span>}
                  </span>
                  <span>{label}</span>{" "}
                </div>

                {current && (
                  <span>
                    <i className="pi pi-chevron-right text-xs font-medium" />
                  </span>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </div>

      {sales && status === "PAID" && (
        <OrderDetailsAlert text={localeText("orderDetailsAlertToProcess")} onDismiss={() => {}} />
      )}
    </>
  );
};

export default OrderDetailsHeaderSection;
